<p-dialog id="searchproduct"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '85vw', height: '80vh'}"
          >

  <ng-template pTemplate="content">
    <div class="grid">
      <div class="xl:col-11 sm:col-10 mt-5 align-self-end">
        <div class="fluid">
          <span class="p-float-label">
            <input id="smtng-input" type="text" (keyup)="onKeyPress($event)" pInputText [(ngModel)]="something">
            <label for="float-input">{{ searchLabel }}</label>
          </span>
        </div>
      </div>
      <div class="xl:col-1 sm:col-2 mt-5 align-self-end" *ngIf="loading" >
        <div class="fluid">
          <p-progressSpinner [style]="{width: '2rem', height: '2rem'}"
                             styleClass="custom-spinner" strokeWidth="4" fill="#EEEEEE" animationDuration=".5s"
                             pTooltip="Поиск" tooltipPosition="top">
          </p-progressSpinner>
        </div>
      </div>

      <div class="xl:col-1 sm:col-12 mt-5 align-self-end" *ngIf="!loading" >
        <div class="fluid">
          <p-button label="Найти" (click)="onSearch($event)" [style]="{width:'100%'}" class="mr-2 ml-2 mt-2 mb-2 align-self-end"></p-button>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="xl:col-2 sm:col-4 mt-2 mb-2 align-self-end">
        <p-checkbox [(ngModel)]="searchOld" label="Искать устаревшие" [binary]="true" [disabled]="!allowOld" (onChange)="onCheckBoxClick($event)"></p-checkbox>
      </div>
      <div class="xl:col-2 sm:col-4 mt-2 mb-2 align-self-end">
        <p-checkbox [(ngModel)]="searchComplex" label="Искать сборные" [binary]="true" [disabled]="!allowComplex" (onChange)="onCheckBoxClick($event)"></p-checkbox>
      </div>
      <div class="xl:col-2 sm:col-4 mt-2 mb-2 align-self-end">
        <p-checkbox [(ngModel)]="showStock" label="Показывать склад" [binary]="true" (onChange)="onCheckBoxClick($event)"></p-checkbox>
      </div>
      <div class="xl:col-2 sm:col-4 mt-2 mb-2 align-self-end">
        <p-checkbox [(ngModel)]="showToolBar" label="Показывать toolBar в окне результатов" [binary]="true"></p-checkbox>
      </div>
    </div>

    <app-list-product-array [initialColumnSet]="resultColumnSet" [rows]="rows" [products]="products" [loading]="loading"
                            [showObsoleteProducts]="showObsoleteProducts" [showToolBar]="showToolBar" noData="Пока ничего не найдено..."
                             state="productSearchDlgState"
                            (productSelected)="onProductSelection($event)" (listIsReady)="onSearchEnd($event)"></app-list-product-array>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (click)="onConfirm()" [disabled]="noSelection"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
